enum NonConformityStatusEnum {
  default = -1, //add
  Pending, //approve ApprovalPending
  NCApproved, //work
  // Active, //verify
  Verify,
  NG,
  Complete,
}

export default NonConformityStatusEnum;
